import React, { useState, useEffect, useRef } from 'react';
import { getAuth } from 'firebase/auth';
import { getDatabase, ref as dbRef, onValue, update, query, orderByChild, limitToLast, get } from 'firebase/database';
import './ChatWindow.css';
import ChatInput from './ChatInput';

const INITIAL_PAGE_SIZE = 30;

const ChatWindow = ({ chatId }) => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(INITIAL_PAGE_SIZE);
    const messagesEndRef = useRef();
    const initialLoad = useRef(true);

    useEffect(() => {
        const auth = getAuth();
        const currentUser = auth.currentUser;
        const database = getDatabase();
        const messagesRef = query(dbRef(database, `Chats/${chatId}/messages`), orderByChild('timestamp'), limitToLast(pageSize));

        const fetchChatAndUserInfo = async () => {
            const chatRef = dbRef(database, `Chats/${chatId}`);
            const chatSnapshot = await get(chatRef);
            if (chatSnapshot.exists()) {
                // Keine zusätzlichen Daten abzurufen, da es nur die Nachrichten anzuzeigen gibt
            }
        };

        fetchChatAndUserInfo();

        const unsubscribe = onValue(messagesRef, (snapshot) => {
            if (snapshot.exists()) {
                const newMessages = [];
                snapshot.forEach(childSnapshot => {
                    newMessages.push({ id: childSnapshot.key, ...childSnapshot.val() });
                });
                setMessages(newMessages);
                markMessagesAsRead(newMessages);
                scrollToBottom();
            }
        });

        return () => {
            unsubscribe();
            initialLoad.current = true;
        };
    }, [chatId, pageSize]);

    useEffect(() => {
        if (initialLoad.current && messages.length > 0) {
            scrollToBottom();
            initialLoad.current = false;
        }
    }, [messages]);

    const markMessagesAsRead = (messages) => {
        const auth = getAuth();
        const database = getDatabase();
        messages.forEach(message => {
            if (message.userId !== auth.currentUser.uid && !message.readStatus) {
                const msgRef = dbRef(database, `Chats/${chatId}/messages/${message.id}`);
                update(msgRef, { readStatus: true });
            }
        });
    };

    const scrollToBottom = () => {
        const scrollContainer = document.querySelector('.messages-list');
        if (scrollContainer) {
            const start = scrollContainer.scrollTop;
            const end = scrollContainer.scrollHeight;
            const distance = end - start;
            const duration = 200;
            const startTime = performance.now();
            const easeInOutQuad = (t) => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

            const scrollStep = (timestamp) => {
                const currentTime = timestamp - startTime;
                const scrollProgress = easeInOutQuad(Math.min(1, currentTime / duration));
                scrollContainer.scrollTop = start + distance * scrollProgress;

                if (currentTime < duration) {
                    requestAnimationFrame(scrollStep);
                }
            };

            requestAnimationFrame(scrollStep);
        }
    };

    const loadMoreMessages = () => {
        if (!loading) {
            setLoading(true);
            setPageSize(prevPageSize => prevPageSize + INITIAL_PAGE_SIZE);
            setLoading(false);
        }
    };

    return (
        <div className="chat-window">
            <div className="messages-list">
                {messages.length > INITIAL_PAGE_SIZE && (
                    <button onClick={loadMoreMessages} disabled={loading} className="load-more-btn">Load More Messages</button>
                )}
                {messages.map((message) => {
                    const auth = getAuth();
                    const isCurrentUserMessage = message.userId === auth.currentUser.uid;
                    const lastMessage = messages[messages.length - 1];
                    const isLastMessageFromCurrentUser = lastMessage && lastMessage.userId === auth.currentUser.uid;
                    const showReadStatus = isLastMessageFromCurrentUser && lastMessage.id === message.id;

                    if (message.type === "new-order") {
                        return (
                            <div key={message.id} className={`message new-order ${isCurrentUserMessage ? 'right' : 'left'}`}>
                               <h3>A new order was created</h3>
                                <div className="new-order-bubble">
                                    <div className="new-order-top-bar" style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                    <div style={{display: 'flex'}}>
                                    {message.serviceDeliveryTime && (
                     <div className="delivery-info">
                    <img src="./img/delivery_1.svg" alt="Delivery Truck Icon" className="delivery-icon" />
                    <p>{message.serviceDeliveryTime}</p>
                  </div>
                        )}
                                <div style={{display: 'flex'}}>
                                <img style={{width: '15px', marginLeft: '10px', marginRight: '5px', opacity: '0.5'}} src="./img/coin.svg" alt="" />
                                <p style={{fontSize: '14px', color: 'rgb(128, 128, 128)'}}>
                                    {message.credits ? `${message.credits} Credits` : 'Custom Offer'}
                                </p>
                                {message.strategyCall && (
                      <div className="strategy-call-info">
                               <img src="./img/phone1.svg" alt="Strategy Call Icon" className="strategy-call-icon" />
                                <p>Strategy Call</p>
                               </div>
                                  )}
                                </div>
                                </div>
                                        <h3>{message.serviceTitle}</h3>
                                  
                                        </div>
                                     
                                    {message.fileUrl && <img src={message.fileUrl} alt="Order Attachment" />}
                                    <p className="new-message-text">{message.text}</p>
                                    {showReadStatus && (
                                        <div className="read-status">
                                            {message.readStatus ? 'Read' : 'Sent'}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    }

                    return (
                        <div key={message.id} className={`message ${isCurrentUserMessage ? 'right' : 'left'}`}>
                            <div className="bubble">
                                <p>{message.description}</p>
                                {message.fileUrl && <img src={message.fileUrl} alt="Message" />}
                                {showReadStatus && (
                                    <div className="read-status">
                                        {message.readStatus ? 'Read' : 'Sent'}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
                <div ref={messagesEndRef} />
            </div>
            <ChatInput chatId={chatId} />
        </div>
    );
};

export default ChatWindow;
